// Re-export types for backward compatibility
export type { Language, TranslationKeys } from './types';
export { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from './types';

import type { Language, TranslationKeys } from './types';
import { en } from './locales/en';
import { es } from './locales/es';
import { pt } from './locales/pt';
import { fr } from './locales/fr';
import { ar } from './locales/ar';
import { ja } from './locales/ja';
import { ko } from './locales/ko';
import { id } from './locales/id';
import { hi } from './locales/hi';

export const translations: Record<Language, TranslationKeys> = {
  en, es, pt, fr, ar, ja, ko, id, hi,
};
